__turbopack_context__.v({
  "className": "_g4OKW_className",
  "variable": "_g4OKW_variable",
});
